(function () {
  'use strict';

  // Returns the FoxKit variant-images mapping embedded in the card
  // (script[data-pcard-variant-images]), parsed once per gallery element.
  function getVariantMapping(gallery, card) {
    if (gallery.__pcardVariantMapping !== undefined) return gallery.__pcardVariantMapping;

    var mapping = null;
    var jsonEl = card.querySelector('script[data-pcard-variant-images]');
    if (jsonEl) {
      try {
        mapping = (JSON.parse(jsonEl.textContent) || {}).mapping || null;
      } catch (error) {
        mapping = null;
      }
    }
    gallery.__pcardVariantMapping = mapping;
    return mapping;
  }

  // Media ids (strings) grouped to the card's currently selected variant, or
  // null. Requires an explicit variant selection (data-variant-selected, set by
  // product-card-swatch.js on swatch clicks or by Liquid when a collection
  // filter preselects a variant) — without one, the card's hidden variant input
  // merely holds the first available variant, and filtering by it would lock
  // the arrows to that variant's group before the shopper picked anything.
  function getActiveGroupMediaIds(gallery) {
    if (gallery.getAttribute('data-variant-group') !== 'true') return null;
    if (gallery.getAttribute('data-variant-selected') !== 'true') return null;

    var card = gallery.closest('.m-product-card');
    if (!card) return null;

    var input = card.querySelector('input[name="id"]');
    var variantId = input && input.value;
    if (!variantId) return null;

    var mapping = getVariantMapping(gallery, card);
    if (!mapping) return null;

    for (var i = 0; i < mapping.length; i++) {
      if (Number(mapping[i].id) === Number(variantId)) {
        var ids = mapping[i].media;
        return ids && ids.length ? ids : null;
      }
    }
    return null;
  }

  // The slides the arrows cycle through: the selected variant's group (in
  // mapping order) when variant grouping is active, otherwise all slides.
  // Both are capped at the "Max images in arrows navigation" setting.
  function getCycleSlides(gallery, slides) {
    var limit = parseInt(gallery.getAttribute('data-image-limit') || '', 10);
    if (isNaN(limit) || limit < 1) limit = slides.length;

    var groupIds = getActiveGroupMediaIds(gallery);
    if (groupIds) {
      var groupSlides = [];
      groupIds.forEach(function (id) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(id)) {
            groupSlides.push(slides[i]);
            break;
          }
        }
      });
      if (groupSlides.length) return groupSlides.slice(0, limit);
    }
    return slides.slice(0, limit);
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest && event.target.closest('.m-product-card__nav-arrow');
    if (!arrow) return;

    event.preventDefault();
    event.stopPropagation();

    var media = arrow.closest('.m-product-card__media');
    if (!media) return;

    var gallery = media.querySelector('.m-product-card__gallery');
    if (!gallery) return;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.m-product-card__gallery-slide'));
    if (slides.length < 2) return;

    var active = null;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) {
        active = slides[i];
        break;
      }
    }

    var cycle = getCycleSlides(gallery, slides);
    var pos = cycle.indexOf(active);
    // Nothing to cycle unless the active slide sits outside the cycle set
    // (e.g. the initial slide is not part of the selected variant's group).
    if (cycle.length < 2 && pos !== -1) return;

    var direction = arrow.getAttribute('data-direction');
    var next;
    if (pos === -1) {
      next = direction === 'prev' ? cycle[cycle.length - 1] : cycle[0];
    } else if (direction === 'prev') {
      next = cycle[(pos - 1 + cycle.length) % cycle.length];
    } else {
      next = cycle[(pos + 1) % cycle.length];
    }

    if (!next || next === active) return;

    slides.forEach(function (slide) {
      slide.classList.remove('is-active');
    });
    next.classList.add('is-active');
    gallery.setAttribute('data-current-index', String(slides.indexOf(next)));
  });
})();
